import { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';

import { useAppContext } from "@src/contexts/App/AppContext";
import OverlayLoader from './UI/OverlayLoader';
import PopUpContent from './PopUpContent';

const PopUp = () => {

    const [appState, AppActions] = useAppContext();
    const handleClose = () => {
        AppActions.resetAll();
    }

    let hasStatistics = appState.statistics != null;

    return (
        <Modal
            show={hasStatistics}
            onHide={handleClose}
            size="xl"
            backdrop="static"
            keyboard={false}
            centered
        >

            <Modal.Header className="border-bottom-0 p-2" closeButton>
            </Modal.Header>
            <Modal.Body>
                {hasStatistics ? (<PopUpContent />) : null}
            </Modal.Body>
            {appState.isLoading ? <OverlayLoader /> : null}
        </Modal>
    );
}

export default PopUp;

